import React from 'react';
import { Body5 } from '@ui';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper } from '@flow/styles';
import { toCapitalCase } from '@utils/usefulFuncs';

export const DropdownParameter = ({ data, value, onRemove, onChange }) => {
  const { keyName, label, dropdownOptions } = data;

  const handleChange = (e) => {
    const value = e.target.value;
    onChange(keyName, value);
  };
  const handleRemoveClick = () => onRemove(keyName);

  return (
    <AgentFlowParameterWrapper>
      <AgentFlowParameterLabelWrapper>
        <Body5>{label}:</Body5>
      </AgentFlowParameterLabelWrapper>
      <select value={value} onChange={handleChange}>
        <option value={null}>Select One...</option>
        {dropdownOptions.map((option) => (
          <option key={option} value={option}>
            {toCapitalCase(option)}
          </option>
        ))}
      </select>
      <NodeParameterRemoveButton onClick={handleRemoveClick} />
    </AgentFlowParameterWrapper>
  );
};
